export default "__VITE_ASSET__C7o_uo1K__"